import { createApp } from "vue";
import App from "./App.vue";
import BootstrapVue3 from "bootstrap-vue-3";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue-3/dist/bootstrap-vue-3.css";
import "bootstrap/dist/css/bootstrap.min.css";
import { Chart, registerables } from "chart.js";
import "bootstrap-icons/font/bootstrap-icons.css";
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import "bootstrap-vue-next/dist/bootstrap-vue-next.css";
import "@vueform/slider/themes/default.css";
import { createBootstrap } from 'bootstrap-vue-next';
import 'bootstrap-vue-next/dist/bootstrap-vue-next.css';
import 'vue-range-slider/dist/vue-range-slider.css';
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import VueSlider from "@vueform/slider";
import PrimeVue from 'primevue/config';
import '@vueform/slider/themes/default.css';
import store from './store';
import Aura from '@primeuix/themes/aura';
import ApexCharts from "vue3-apexcharts";
import { createVuetify } from "vuetify";
import "vuetify/styles";  
import FloatingVue from 'floating-vue';
import 'floating-vue/dist/style.css';
import '@fortawesome/fontawesome-free/css/all.min.css'


const vuetify = createVuetify({
    components,
    directives,
});
const app = createApp(App); 
Chart.register(...registerables);
app.use(PrimeVue, {
    theme: {
        preset: Aura,
    },
});
app.use(BootstrapVue3);
app.use(createBootstrap);
app.use(ElementPlus);
app.use(store);
app.use(vuetify);
app.use(FloatingVue);  

app.component("apexchartGraph", ApexCharts);
app.component("VueSlider", VueSlider);
app.mount("#app");
